import { Text } from "@krea/shared/design-system/Text";
import { cn } from "@krea/shared/utils";

export interface IEarlyRepaymentCommentBoxProps {
  /** "Comment" to the lender who wrote it, "Lender's comment" elsewhere. */
  label: string;
  comment: string;
  className?: string;
}

/**
 * The lender's free-text note, kept visually separate from the structured
 * terms — it used to be concatenated on as `terms — comment`, which read as
 * though the note were one of the agreed terms.
 */
export const EarlyRepaymentCommentBox = ({
  label,
  comment,
  className,
}: IEarlyRepaymentCommentBoxProps) => (
  <div
    className={cn(
      "rounded-md border border-gray-300 bg-gray-100 px-3 py-2",
      className,
    )}
  >
    <Text className="text-label font-medium">{label}</Text>
    {/* Typed into a textarea, so newlines the lender entered are meaningful. */}
    <Text className="whitespace-pre-line text-helper">{comment}</Text>
  </div>
);
